import React, { Component } from "react";
import { connect } from "react-redux";
import M from "materialize-css/dist/js/materialize.min.js";
import $ from "jquery";
import { Link } from "react-router-dom";
import { updateSettings } from "../../actions/ui/settings";
import { settings } from "../../config.js";
import Modal from "../helper/modal";

class Settings extends Component {
  state = this.props.settings;
  componentDidMount() {
    let _this = this;
  }
  saveModal() {
    let settings = this.state;
    let _this = this;
    this.props.networksettings.forEach(({id}) => {settings[id] = $(`#${id}`)[0].value.trim()});
    if (!Number.isInteger(parseFloat(settings.deposit)) || !Number.isInteger(parseFloat(settings.settlement))) {
      M.toast({html: "Settlement and Trade Lifespan Must be Integers", classes: "red", displayLength: 3000});
    }
    else if (parseFloat(settings.deposit) < 5) {
      M.toast({html: "Trade Lifespan must be greater than or equal to 5 blocks", classes: "red", displayLength: 3000});
    }
    else if (parseFloat(settings.settlement) > 10000) {
      M.toast({html: "Settlement Period must be less than or equal to 10,000 blocks", classes: "red", displayLength: 3000});
    }
    else if (parseFloat(settings.settlement) <= parseFloat(settings.deposit)) {
      M.toast({ html: "Settlement must be greater than Trade Lifespan", classes: "red", displayLength: 3000});
    }
    else {
      _this.props.updateSettings(settings, () => {});
      M.toast({ html: "Successfully Saved", classes: "green", displayLength: 3000});
      var instance = M.Modal.getInstance(document.querySelectorAll("#modalSettings")[0]);
      if (instance) instance.close();
    }
    return
  }
  renderModal() {
    let component = this.network();
    return (
      <Modal
        id="modalSettings"
        classes="modal modalOrders black-text"
        title="Confirm Logout"
        style={{maxWidth:'500px'}}
        buttonAction={this.saveModal.bind(this)}
        noClose={true}
        component={<h6 style={{paddingTop:'10px'}}>Logging out will delete all locally saved data within the browser.</h6>}
        logout={true}
      />
    );
  }
  network() {
    let settings = this.props.networksettings;
    let items = settings.map(({placeholder, title, id, max, min}, i) => {
      return (
        <div key={i} className="col" style={{width:'450px',padding:'2px 10px'}}>
          <h6 style={{margin:'10px 0px', fontSize: "0.8rem", float: "left", lineHeight: "30px",color:'grey' }}>
            <b>{title}</b>
          </h6>
          <input placeholder={placeholder} id={id} type={"number"} min={parseInt(min)} max={parseInt(max)} className="black-text" style={{borderBottom:'0',width:'50%',float: "right",marginTop: "5px",fontFamily: "Gilmer-Light", letterSpacing: "0.5px"}}/>
        </div>
      );
    });
    return (
      <div className="row mbd" id="network">
        {items}
      </div>
    );
  }
  openModal() {
    let _this = this;
    if (document.querySelectorAll("#modalSettings")[0]) {
      var instance = M.Modal.getInstance(document.querySelectorAll("#modalSettings")[0]);
      if (instance) instance.open();
      setTimeout(() => {
        // _this.props.networksettings.forEach(({ id }) => {
        //   $(`#${id}`)[0].value = _this.state[id];
        // });
      }, 100);
    }
  }
  render() {
    return (
      <div>
        {this.renderModal()}
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  let networksettings = [
    {
      title: "Trade Lifespan (OL Blocks)",
      id: "deposit",
      max: 1000,
      min: 10,
      placeholder:100
    },
    {
      title: "Settlement Period (OL Blocks)",
      id: "settlement",
      max: 1000,
      min: 10,
      placeholder:200
    },
  ];

  return {
    settings: state.settings.settings,
    networksettings
  };
}

export default connect(mapStateToProps,{updateSettings})(Settings);
